// // import { useState } from "react";
// // import { Link, useLocation } from "react-router-dom";
// // import { motion, AnimatePresence } from "framer-motion";

// // const Navbar = () => {
// //   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
// //   const [servicesOpen, setServicesOpen] = useState(false);
// //   const location = useLocation();

// //   // Navigation items with exact paths matching your Routes
// //   const navigation = [
// //     { title: "Home", path: "/" },
// //     {
// //       title: "Services",
// //       path: "/services",
// //       submenu: [
// //         { title: "Data Build", path: "/dataBuildservices" },
// //         { title: "Customer Support Services", path: "/customersupportservices" },
// //         { title: "Webinar Registration Services", path: "/Webinarregistrationservices" },
// //         { title: "Telecalling Services", path: "/telecallingservices" },
// //         { title: "Lead Generation", path: "/leadgenration" },
// //       ],
// //     },
// //     { title: "Career", path: "/career" },
// //     { title: "About Us", path: "/about" },
// //     { title: "Contact Us", path: "/contact" },
// //   ];

// //   // Helper to check active link highlighting
// //   const isActive = (path) => {
// //     return location.pathname === path;
// //   };

// //   return (
// //     <nav className="bg-white sticky top-0 z-50 shadow-md border-b border-gray-200">
// //       <div className="max-w-screen-xl mx-auto px-4 md:px-8 flex items-center justify-between h-16">
// //         {/* Logo */}
// //         <Link
// //           to="/"
// //           className="text-2xl font-extrabold text-blue-700 hover:text-blue-800 transition"
// //           aria-label="Augere Strategies  Home"
// //           onClick={() => setMobileMenuOpen(false)}
// //         >
// //           Augere Strategies
// //         </Link>

// //         {/* Desktop Navigation */}
// //         <ul className="hidden md:flex space-x-8 items-center">
// //           {navigation.map((item, idx) => (
// //             <li key={idx} className="relative group">
// //               {item.submenu ? (
// //                 <>
// //                   {/* Services parent link is not a actual route but a toggle on mobile */}
// //                   <button
// //                     type="button"
// //                     className={`flex items-center gap-1 font-semibold ${
// //                       isActive(item.path) ? "text-blue-600" : "text-gray-700 hover:text-blue-600"
// //                     } transition`}
// //                     onClick={() => setServicesOpen(!servicesOpen)}
// //                     onMouseEnter={() => setServicesOpen(true)}
// //                     onMouseLeave={() => setServicesOpen(false)}
// //                     aria-haspopup="true"
// //                     aria-expanded={servicesOpen ? "true" : "false"}
// //                   >
// //                     {item.title}
// //                     <svg
// //                       className={`w-4 h-4 transform transition-transform ${
// //                         servicesOpen ? "rotate-180" : "rotate-0"
// //                       }`}
// //                       fill="none"
// //                       stroke="currentColor"
// //                       strokeWidth={2}
// //                       viewBox="0 0 24 24"
// //                       strokeLinecap="round"
// //                       strokeLinejoin="round"
// //                       aria-hidden="true"
// //                     >
// //                       <path d="M19 9l-7 7-7-7"></path>
// //                     </svg>
// //                   </button>
// //                   {/* Submenu desktop */}
// //                   <AnimatePresence>
// //                     {servicesOpen && (
// //                       <motion.ul
// //                         initial={{ opacity: 0, y: 5 }}
// //                         animate={{ opacity: 1, y: 0 }}
// //                         exit={{ opacity: 0, y: 5 }}
// //                         transition={{ duration: 0.2 }}
// //                         onMouseEnter={() => setServicesOpen(true)}
// //                         onMouseLeave={() => setServicesOpen(false)}
// //                         className="absolute top-full left-0 mt-2 w-56 bg-white rounded-md shadow-lg border border-gray-200 py-2 z-50"
// //                         role="menu"
// //                         aria-label="submenu"
// //                       >
// //                         {item.submenu.map((subItem, subIdx) => (
// //                           <li key={subIdx} role="none">
// //                             <Link
// //                               to={subItem.path}
// //                               className={`block px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition ${
// //                                 isActive(subItem.path) ? "font-semibold text-blue-600" : ""
// //                               }`}
// //                               role="menuitem"
// //                               onClick={() => setMobileMenuOpen(false)}
// //                             >
// //                               {subItem.title}
// //                             </Link>
// //                           </li>
// //                         ))}
// //                       </motion.ul>
// //                     )}
// //                   </AnimatePresence>
// //                 </>
// //               ) : (
// //                 <Link
// //                   to={item.path}
// //                   className={`font-semibold ${
// //                     isActive(item.path) ? "text-blue-600" : "text-gray-700 hover:text-blue-600"
// //                   } transition`}
// //                   onClick={() => setMobileMenuOpen(false)}
// //                 >
// //                   {item.title}
// //                 </Link>
// //               )}
// //             </li>
// //           ))}
// //         </ul>

// //         {/* CTA + Call Us on desktop */}
// //         <div className="hidden md:flex items-center space-x-6">
// //           <div className="text-right">
// //             <p className="text-xs text-gray-500 select-none">CALL US TOO!</p>
// //             <a
// //               href="tel:7021216035"
// //               className="font-semibold text-gray-800 hover:text-blue-600 transition"
// //               aria-label="Call us at +44 1416 282 052"
// //             >
// //               7021216035/8828357920
// //             </a>
// //           </div>
// //           <Link
// //             to="/get-quote"
// //             className="bg-blue-600 hover:bg-blue-700 text-white text-sm md:text-base font-semibold rounded-md px-4 py-2 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition"
// //           >
// //             Get Quote
// //           </Link>
// //         </div>

// //         {/* Mobile menu button */}
// //         <div className="md:hidden">
// //           <button
// //             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
// //             aria-label="Toggle Navigation Menu"
// //             aria-expanded={mobileMenuOpen}
// //             className="text-gray-700 p-2 rounded-md hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
// //           >
// //             {mobileMenuOpen ? (
// //               // Close icon
// //               <svg
// //                 xmlns="http://www.w3.org/2000/svg"
// //                 className="h-6 w-6"
// //                 fill="none"
// //                 viewBox="0 0 24 24"
// //                 stroke="currentColor"
// //                 aria-hidden="true"
// //               >
// //                 <path
// //                   strokeLinecap="round"
// //                   strokeLinejoin="round"
// //                   strokeWidth={2}
// //                   d="M6 18L18 6M6 6l12 12"
// //                 />
// //               </svg>
// //             ) : (
// //               // Hamburger menu icon
// //               <svg
// //                 xmlns="http://www.w3.org/2000/svg"
// //                 className="h-6 w-6"
// //                 fill="none"
// //                 viewBox="0 0 24 24"
// //                 stroke="currentColor"
// //                 aria-hidden="true"
// //               >
// //                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
// //               </svg>
// //             )}
// //           </button>
// //         </div>
// //       </div>

// //       {/* Mobile Menu */}
// //       <AnimatePresence>
// //         {mobileMenuOpen && (
// //           <motion.div
// //             initial={{ height: 0, opacity: 0 }}
// //             animate={{ height: "auto", opacity: 1 }}
// //             exit={{ height: 0, opacity: 0 }}
// //             transition={{ duration: 0.25 }}
// //             className="md:hidden bg-white border-t border-gray-200 shadow-lg overflow-hidden"
// //           >
// //             <ul className="flex flex-col px-6 py-4 space-y-4">
// //               {navigation.map((item, idx) => (
// //                 <li key={idx} className="flex flex-col">
// //                   {item.submenu ? (
// //                     <>
// //                       <button
// //                         type="button"
// //                         className="flex items-center justify-between w-full font-semibold text-gray-700 hover:text-blue-600"
// //                         onClick={() => setServicesOpen(!servicesOpen)}
// //                         aria-expanded={servicesOpen}
// //                         aria-controls="mobile-submenu"
// //                       >
// //                         <span>{item.title}</span>
// //                         <svg
// //                           className={`w-5 h-5 transform transition-transform ${
// //                             servicesOpen ? "rotate-180" : "rotate-0"
// //                           }`}
// //                           fill="none"
// //                           stroke="currentColor"
// //                           strokeWidth={2}
// //                           viewBox="0 0 24 24"
// //                           strokeLinecap="round"
// //                           strokeLinejoin="round"
// //                           aria-hidden="true"
// //                         >
// //                           <path d="M19 9l-7 7-7-7"></path>
// //                         </svg>
// //                       </button>
// //                       <AnimatePresence>
// //                         {servicesOpen && (
// //                           <motion.ul
// //                             id="mobile-submenu"
// //                             initial={{ opacity: 0, height: 0 }}
// //                             animate={{ opacity: 1, height: "auto" }}
// //                             exit={{ opacity: 0, height: 0 }}
// //                             transition={{ duration: 0.3 }}
// //                             className="pl-4 mt-2 flex flex-col space-y-2 overflow-hidden"
// //                           >
// //                             {item.submenu.map((subItem, subIdx) => (
// //                               <li key={subIdx}>
// //                                 <Link
// //                                   to={subItem.path}
// //                                   className="block text-gray-600 hover:text-blue-600"
// //                                   onClick={() => setMobileMenuOpen(false)}
// //                                 >
// //                                   {subItem.title}
// //                                 </Link>
// //                               </li>
// //                             ))}
// //                           </motion.ul>
// //                         )}
// //                       </AnimatePresence>
// //                     </>
// //                   ) : (
// //                     <Link
// //                       to={item.path}
// //                       className={`font-semibold ${
// //                         isActive(item.path) ? "text-blue-600" : "text-gray-700 hover:text-blue-600"
// //                       }`}
// //                       onClick={() => setMobileMenuOpen(false)}
// //                     >
// //                       {item.title}
// //                     </Link>
// //                   )}
// //                 </li>
// //               ))}
// //               {/* Mobile CTA */}
// //               <li className="pt-4 border-t border-gray-200">
// //                 <a
// //                   href="tel:+441416282052"
// //                   className="block mb-3 text-center font-semibold text-blue-800 hover:text-blue-600"
// //                 >
// //                   Call us: 7021216035/8828357920
// //                 </a>
// //                 <Link
// //                   to="/get-quote"
// //                   className="block text-center bg-blue-600 rounded-md px-6 py-2 font-semibold text-white hover:bg-blue-700 transition"
// //                   onClick={() => setMobileMenuOpen(false)}
// //                 >
// //                   Get Quote
// //                 </Link>
// //               </li>
// //             </ul>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>
// //     </nav>
// //   );
// // };

// // export default Navbar;

// import { useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";

// const NAV_ITEMS = [
//   { title: "Home", path: "/" },
//   { title: "About Us", path: "/about" },
//   {
//     title: "Services",
//     path: "/services",
//     submenu: [
//       { title: "Data Build", path: "/dataBuildservices" },
//       { title: "U.S Mortgage Underwriting", path: "/mortgageservices" },

//       { title: "Customer Support Services", path: "/customersupportservices" },
//       { title: "Webinar Registration", path: "/Webinarregistrationservices" },
//       // { title: "Telecalling Services", path: "/telecallingservices" },
//       { title: "Lead Generation", path: "/leadgenration" },
//     ],
//   },
//   { title: "Career", path: "/career" },

//   { title: "Contact Us", path: "/contact" },
// ];

// const Navbar = () => {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [servicesOpen, setServicesOpen] = useState(false);
//   const location = useLocation();

//   // Helper to detect active route
//   const isActive = (path) => location.pathname === path;

//   // Only one dropdown open at a time, so control in mobile menu
//   const handleServiceToggle = () => setServicesOpen((open) => !open);

//   // Close menus on route change (desktop)
//   const handleNavLinkClick = () => setMobileMenuOpen(false);

//   return (
//     <nav className="bg-white sticky top-0 z-50 shadow-md border-b border-gray-200">
//       <div className="max-w-screen-xl mx-auto px-4 md:px-8 flex items-center justify-between h-16">
//         {/* Logo */}
//         <Link
//           to="/"
//           className="text-2xl font-extrabold text-blue-700 hover:text-blue-800 transition"
//           aria-label="Augere Strategies  Home"
//           onClick={handleNavLinkClick}
//         >
//           Augere Strategies
//         </Link>

//         {/* Desktop Navigation */}
//         <ul className="hidden md:flex space-x-8 items-center">
//           {NAV_ITEMS.map((item, idx) => (
//             <li key={idx} className="relative group">
//               {item.submenu ? (
//                 <>
//                   <button
//                     type="button"
//                     className={`flex items-center gap-1 font-semibold ${
//                       location.pathname.startsWith("/dataBuildservices") ||
//                       location.pathname.startsWith(
//                         "/customersupportservices"
//                       ) ||
//                       location.pathname.startsWith(
//                         "/Webinarregistrationservices"
//                       ) ||
//                       location.pathname.startsWith("/telecallingservices") ||
//                       location.pathname.startsWith("/leadgenration")
//                         ? "text-blue-600"
//                         : "text-gray-700 hover:text-blue-600"
//                     } transition`}
//                     aria-haspopup="true"
//                     aria-expanded={servicesOpen ? "true" : "false"}
//                     onClick={() => setServicesOpen(!servicesOpen)}
//                     onMouseEnter={() => setServicesOpen(true)}
//                     onMouseLeave={() => setServicesOpen(false)}
//                   >
//                     {item.title}
//                     <svg
//                       className={`w-4 h-4 transform transition-transform ${
//                         servicesOpen ? "rotate-180" : ""
//                       }`}
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth={2}
//                       viewBox="0 0 24 24"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     >
//                       <path d="M19 9l-7 7-7-7"></path>
//                     </svg>
//                   </button>
//                   <AnimatePresence>
//                     {servicesOpen && (
//                       <motion.ul
//                         initial={{ opacity: 0, y: 6 }}
//                         animate={{ opacity: 1, y: 0 }}
//                         exit={{ opacity: 0, y: 6 }}
//                         transition={{ duration: 0.18 }}
//                         onMouseEnter={() => setServicesOpen(true)}
//                         onMouseLeave={() => setServicesOpen(false)}
//                         className="absolute top-full left-0 mt-2 w-56 bg-white rounded-md shadow-lg border border-gray-200 py-2 z-50"
//                         role="menu"
//                         aria-label="submenu"
//                       >
//                         {item.submenu.map((sub, subIdx) => (
//                           <li key={subIdx} role="none">
//                             <Link
//                               to={sub.path}
//                               className={`block px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition ${
//                                 isActive(sub.path)
//                                   ? "font-semibold text-blue-600"
//                                   : ""
//                               }`}
//                               role="menuitem"
//                               onClick={handleNavLinkClick}
//                             >
//                               {sub.title}
//                             </Link>
//                           </li>
//                         ))}
//                       </motion.ul>
//                     )}
//                   </AnimatePresence>
//                 </>
//               ) : (
//                 <Link
//                   to={item.path}
//                   className={`font-semibold ${
//                     isActive(item.path)
//                       ? "text-blue-600"
//                       : "text-gray-700 hover:text-blue-600"
//                   } transition`}
//                   onClick={handleNavLinkClick}
//                 >
//                   {item.title}
//                 </Link>
//               )}
//             </li>
//           ))}
//         </ul>

//         {/* CTA + Call Us (Desktop) */}
//         <div className="hidden md:flex items-center space-x-6">
//           {/* <div className="text-right">
//             <p className="text-xs text-gray-500 select-none">CALL US TOO!</p>
//             <a
//               href="tel:7021216035"
//               className="font-semibold text-gray-800 hover:text-blue-600 transition"
//               aria-label="Call us at 7021216035"
//             >
//               7021216035/8828357920
//             </a>
//           </div> */}
//           {/* <Link
//             to="/contact"
//             className="bg-blue-600 hover:bg-blue-700 text-white text-sm md:text-base font-semibold rounded-md px-4 py-2 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition"
//             onClick={handleNavLinkClick}
//           >
//             Get Quote
//           </Link> */}
//           <a
//             href="/contact"
//             className="bg-blue-600 hover:bg-blue-700 text-white text-sm md:text-base font-semibold rounded-md px-4 py-2 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition"
//             onClick={handleNavLinkClick}
//           >
//             Get Quote
//           </a>
//         </div>

//         {/* Mobile Menu Toggle Button */}
//         <div className="md:hidden">
//           <button
//             onClick={() => setMobileMenuOpen((m) => !m)}
//             aria-label="Toggle Navigation Menu"
//             aria-expanded={mobileMenuOpen}
//             className="text-gray-700 p-2 rounded-md hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
//           >
//             {mobileMenuOpen ? (
//               // Close icon
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="h-6 w-6"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M6 18L18 6M6 6l12 12"
//                 />
//               </svg>
//             ) : (
//               // Hamburger menu icon
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="h-6 w-6"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M4 6h16M4 12h16M4 18h16"
//                 />
//               </svg>
//             )}
//           </button>
//         </div>
//       </div>

//       {/* Mobile Menu */}
//       <AnimatePresence>
//         {mobileMenuOpen && (
//           <motion.div
//             initial={{ height: 0, opacity: 0 }}
//             animate={{ height: "auto", opacity: 1 }}
//             exit={{ height: 0, opacity: 0 }}
//             transition={{ duration: 0.21 }}
//             className="md:hidden bg-white border-t border-gray-200 shadow-lg overflow-hidden"
//           >
//             <ul className="flex flex-col px-6 py-4 space-y-4">
//               {NAV_ITEMS.map((item, idx) => (
//                 <li key={idx} className="flex flex-col">
//                   {item.submenu ? (
//                     <>
//                       <button
//                         type="button"
//                         className="flex items-center justify-between w-full font-semibold text-gray-700 hover:text-blue-600"
//                         onClick={handleServiceToggle}
//                         aria-expanded={servicesOpen}
//                         aria-controls="mobile-submenu"
//                       >
//                         <span>{item.title}</span>
//                         <svg
//                           className={`w-5 h-5 transform transition-transform ${
//                             servicesOpen ? "rotate-180" : "rotate-0"
//                           }`}
//                           fill="none"
//                           stroke="currentColor"
//                           strokeWidth={2}
//                           viewBox="0 0 24 24"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         >
//                           <path d="M19 9l-7 7-7-7"></path>
//                         </svg>
//                       </button>
//                       <AnimatePresence>
//                         {servicesOpen && (
//                           <motion.ul
//                             id="mobile-submenu"
//                             initial={{ opacity: 0, height: 0 }}
//                             animate={{ opacity: 1, height: "auto" }}
//                             exit={{ opacity: 0, height: 0 }}
//                             transition={{ duration: 0.2 }}
//                             className="pl-4 mt-2 flex flex-col space-y-2 overflow-hidden"
//                           >
//                             {item.submenu.map((sub, subIdx) => (
//                               <li key={subIdx}>
//                                 <Link
//                                   to={sub.path}
//                                   className="block text-gray-600 hover:text-blue-600"
//                                   onClick={handleNavLinkClick}
//                                 >
//                                   {sub.title}
//                                 </Link>
//                               </li>
//                             ))}
//                           </motion.ul>
//                         )}
//                       </AnimatePresence>
//                     </>
//                   ) : (
//                     <Link
//                       to={item.path}
//                       className={`font-semibold ${
//                         isActive(item.path)
//                           ? "text-blue-600"
//                           : "text-gray-700 hover:text-blue-600"
//                       }`}
//                       onClick={handleNavLinkClick}
//                     >
//                       {item.title}
//                     </Link>
//                   )}
//                 </li>
//               ))}

//               {/* Mobile CTA */}
//               <li className="pt-4 border-t border-gray-200">
//                 {/* <a
//                   href="tel:7021216035"
//                   className="block mb-3 text-center font-semibold text-blue-800 hover:text-blue-600"
//                 >
//                   Call us: 7021216035/8828357920
//                 </a> */}
//                 {/* <Link
//                   to="/get-quote"
//                   className="block text-center bg-blue-600 rounded-md px-6 py-2 font-semibold text-white hover:bg-blue-700 transition"
//                   onClick={handleNavLinkClick}
//                 >
//                   Get Quote
//                 </Link> */}

//                 <a
//                   href="/get-quote"
//                   className="block text-center bg-blue-600 rounded-md px-6 py-2 font-semibold text-white hover:bg-blue-700 transition"
//                   onClick={handleNavLinkClick}
//                 >
//                   Get Quote
//                 </a>
//               </li>
//             </ul>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </nav>
//   );
// };

// export default Navbar;

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const NAV_ITEMS = [
  { title: "Home", path: "/" },
  { title: "About Us", path: "/about" },
  {
    title: "Services",
    path: "/services",
    submenu: [
      { title: "Data Build", path: "/dataBuildservices" },
      { title: "U.S Mortgage Underwriting", path: "/mortgageservices" },
      { title: "Customer Support Services", path: "/customersupportservices" },
      { title: "Webinar Registration", path: "/Webinarregistrationservices" },
      { title: "Lead Generation", path: "/leadgenration" },
    ],
  },
  { title: "Career", path: "/career" },
  { title: "Contact Us", path: "/contact" },
];

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const handleServiceToggle = () => setServicesOpen((open) => !open);
  const handleNavLinkClick = () => setMobileMenuOpen(false);

  return (
    <nav className="bg-white sticky top-0 z-50 shadow-md border-b border-gray-200">
      <div className="max-w-screen-xl mx-auto px-4 md:px-8 flex items-center justify-between h-16">
        {/* Logo */}
        <a
          href="/"
          className="text-2xl font-extrabold text-blue-700 hover:text-blue-800 transition"
          aria-label="Augere Strategies Home"
          onClick={handleNavLinkClick}
        >
          Augere Strategies
        </a>

        {/* Desktop Navigation */}
        <ul className="hidden md:flex space-x-8 items-center">
          {NAV_ITEMS.map((item, idx) => (
            <li key={idx} className="relative group">
              {item.submenu ? (
                <>
                  <button
                    type="button"
                    className="flex items-center gap-1 font-semibold text-gray-700 hover:text-blue-600 transition"
                    aria-haspopup="true"
                    aria-expanded={servicesOpen ? "true" : "false"}
                    onClick={() => setServicesOpen(!servicesOpen)}
                    onMouseEnter={() => setServicesOpen(true)}
                    onMouseLeave={() => setServicesOpen(false)}
                  >
                    {item.title}
                    <svg
                      className={`w-4 h-4 transform transition-transform ${
                        servicesOpen ? "rotate-180" : ""
                      }`}
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      viewBox="0 0 24 24"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M19 9l-7 7-7-7"></path>
                    </svg>
                  </button>
                  <AnimatePresence>
                    {servicesOpen && (
                      <motion.ul
                        initial={{ opacity: 0, y: 6 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 6 }}
                        transition={{ duration: 0.18 }}
                        onMouseEnter={() => setServicesOpen(true)}
                        onMouseLeave={() => setServicesOpen(false)}
                        className="absolute top-full left-0 mt-2 w-56 bg-white rounded-md shadow-lg border border-gray-200 py-2 z-50"
                        role="menu"
                        aria-label="submenu"
                      >
                        {item.submenu.map((sub, subIdx) => (
                          <li key={subIdx} role="none">
                            <a
                              href={sub.path}
                              className="block px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition"
                              role="menuitem"
                              onClick={handleNavLinkClick}
                            >
                              {sub.title}
                            </a>
                          </li>
                        ))}
                      </motion.ul>
                    )}
                  </AnimatePresence>
                </>
              ) : (
                <a
                  href={item.path}
                  className="font-semibold text-gray-700 hover:text-blue-600 transition"
                  onClick={handleNavLinkClick}
                >
                  {item.title}
                </a>
              )}
            </li>
          ))}
        </ul>

        {/* CTA (Desktop) */}
        <div className="hidden md:flex items-center space-x-6">
          <a
            href="/contact"
            className="bg-blue-600 hover:bg-blue-700 text-white text-sm md:text-base font-semibold rounded-md px-4 py-2 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition"
            onClick={handleNavLinkClick}
          >
            Get Quote
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <div className="md:hidden">
          <button
            onClick={() => setMobileMenuOpen((m) => !m)}
            aria-label="Toggle Navigation Menu"
            aria-expanded={mobileMenuOpen}
            className="text-gray-700 p-2 rounded-md hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {mobileMenuOpen ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.21 }}
            className="md:hidden bg-white border-t border-gray-200 shadow-lg overflow-hidden"
          >
            <ul className="flex flex-col px-6 py-4 space-y-4">
              {NAV_ITEMS.map((item, idx) => (
                <li key={idx} className="flex flex-col">
                  {item.submenu ? (
                    <>
                      <button
                        type="button"
                        className="flex items-center justify-between w-full font-semibold text-gray-700 hover:text-blue-600"
                        onClick={handleServiceToggle}
                        aria-expanded={servicesOpen}
                        aria-controls="mobile-submenu"
                      >
                        <span>{item.title}</span>
                        <svg
                          className={`w-5 h-5 transform transition-transform ${
                            servicesOpen ? "rotate-180" : "rotate-0"
                          }`}
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          viewBox="0 0 24 24"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M19 9l-7 7-7-7"></path>
                        </svg>
                      </button>
                      <AnimatePresence>
                        {servicesOpen && (
                          <motion.ul
                            id="mobile-submenu"
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: "auto" }}
                            exit={{ opacity: 0, height: 0 }}
                            transition={{ duration: 0.2 }}
                            className="pl-4 mt-2 flex flex-col space-y-2 overflow-hidden"
                          >
                            {item.submenu.map((sub, subIdx) => (
                              <li key={subIdx}>
                                <a
                                  href={sub.path}
                                  className="block text-gray-600 hover:text-blue-600"
                                  onClick={handleNavLinkClick}
                                >
                                  {sub.title}
                                </a>
                              </li>
                            ))}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </>
                  ) : (
                    <a
                      href={item.path}
                      className="font-semibold text-gray-700 hover:text-blue-600 transition"
                      onClick={handleNavLinkClick}
                    >
                      {item.title}
                    </a>
                  )}
                </li>
              ))}

              {/* Mobile CTA */}
              <li className="pt-4 border-t border-gray-200">
                <a
                  href="/get-quote"
                  className="block text-center bg-blue-600 rounded-md px-6 py-2 font-semibold text-white hover:bg-blue-700 transition"
                  onClick={handleNavLinkClick}
                >
                  Get Quote
                </a>
              </li>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
